
import React, { useState, useEffect } from 'react';
import ServiceCard from './ServiceCard';
import "../ScrollReveal.css";
import ScrollRevealDiv from "./ScrollRevealDiv";
import { GoMoveToTop } from "react-icons/go";

const Section = ({ image, title, text }) => (
  <ScrollRevealDiv>
    <div className="emb-section">
      <img src={image} alt={title} className="emb-image" />

      <div className="emb-text">
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
    </div>
  </ScrollRevealDiv>
);

const Embroidery = () => {
  return (
    <div className="emb-container">
      <ServiceCard
        id="#"
        title="Embroidery"
        description="Embroidery is a classic method of garment decoration where your design is stitched directly into fabric, offering a textured, durable, and professional look. Ideal for corporate wear, hats, jackets, and uniforms."
                       fullDescription={` Embroidery is one of the oldest and most enduring forms of garment decoration, dating back thousands of years to ancient China, Egypt, and the Middle East. Historically, it was used to convey status and artistry, with intricate designs adorning robes, tapestries, and ceremonial garments.

Today, embroidery transforms your logo or design into a stitch file through digitization. Multi-needle embroidery machines then replicate the design with precision on garments and accessories like polos, beanies, backpacks, towels, and more. Unlike prints, embroidery is highly durable and retains its color, structure, and texture even after repeated washes and outdoor use.

We offer a wide range of thread colors, including metallic, neon, and glow threads, with standard or custom placement options. Attention to detail—from thread tension to stitch density—ensures every item looks polished and professional, whether you need a few pieces or hundreds.`}
        images={[]}
      />

      <Section 
        image="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925280/my_uploads/no1ancolk9zl4oqbsnzo.png"
        title="Basic Embroidery"
        text="W & W Boutique offers custom embroidery for logos on shirts, hats, bags, jackets, and more. Clean, professional, and long-lasting results."
      />

      <Section
        image="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925282/my_uploads/u1fx9f3ncncjfx6ozzyl.png"
        title="Embroidery Specialties"
        text="Make your design stand out with specialty embroidery techniques including textured fills, layered stitching, and premium finishes."
      />

      <Section
        image="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925284/my_uploads/mwcbfghdsttfposdjbus.png"
        title="Art For Embroidery"
        text="Vector and high-resolution artwork produce the best embroidery results. We accept most file formats and handle digitization in-house."
      />

      <Section
        image="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925285/my_uploads/zf2k83jomjoig14pv1ty.png"
        title="Stitch Types"
        text="Depending on fabric and design, we use satin, fill, or walking stitches to achieve the best visual and structural results."
      />

      <Section
        image="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925287/my_uploads/bowrpaopalym0pntdlqr.png"
        title="Thread Types"
        text="Rayon and polyester threads are available. Each offers unique benefits in shine, durability, and color retention."
      />

      <div className="emb-top">
        <a href="#" className="top-link">
          <GoMoveToTop size={30} />
          <span>Top</span>
        </a>
      </div>
    </div>
  );
};

export default Embroidery;
